<!-- 学生票二次确认弹窗 -->
<template minapp='mpx' xlang='wxml'>
  <contact-dialog
    show="{{show}}"
    title="{{title}}"
    confirmText="确认"
    content="{{content}}"
    bind:confirm="confirmtDialog"
    class="register-dialog"
  >
    <view class="inner-icon" slot="icon">
      <image class="inner-image"  src="{{icon}}"/>
    </view>
  </contact-dialog>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import { trackEvent } from '@/common/track'
  createComponent({
    componentName: 'successDialog',
    props: {
      show: {
        type: Boolean,
        value: false
      },
      msg:{
        type: String,
        value:''
      },
      title:{
        type: String,
        value:'注册失败'
      }
    },

    computed:{
      content(){
        const errMsg = this.msg? `因${this.msg}` : ''
        return `${errMsg}注册失败，请检查后重新填写信息`
      }
    },

    data:{
      icon:"https://ut-static.udache.com/webx/sfc/OvOwTaVenTCd0q72Q_xhW.png"
    },
    methods: {
      confirmtDialog() {
        trackEvent('userteam_train_regpage_sucesspop_ck', 'UT-火车票-注册页面-注册成功弹窗-点击',{
          type: this.title === '注册失败' ?'regfail' : 'checkfail'
        })
        this.$trigger('confirm')
      }
    },
    watch: {
      show: {
        handler(val, old) {
          val && trackEvent('userteam_train_regpage_sucesspop_sw', 'UT-火车票-注册页面-注册成功弹窗-曝光',{
            type: this.title === '注册失败' ?'regfail' : 'checkfail'
            
          })
        }
      }
    },
    mounted() {}
  })
</script>

<style lang='stylus' scoped>
  .inner-box
    background #F6F7F8
    padding 8px
    font-size 12px 
    line-height 16px
    color #666
    margin 12px 0
    border-radius 8px
    .inner-text
      margin-top 4px
      font-family PingFangSC-Medium;
      font-size 14px;
      font-weight normal;
      line-height 18px;
      letter-spacing 0px;
      color #333333;
      &:first-child
        margin-top 0
  .inner-icon
    display flex
    justify-content center
    margin-bottom 5px
    .inner-image
      width 63px
      height 67px
  .register-dialog
    /deep/ .contact-dialog-content
      max-height 85px
      text-align center
      overflow-y scroll
    /deep/ .contact-dialog-confirm
      margin-left 0

</style>

<script name='json'>
  module.exports = {
    component: true,
    "usingComponents": {
      'contact-dialog': '@/pages/contact/components/contact-dialog/index'
    }
  }
</script>

